import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { log } from "console";
import { InstallmentConfigService } from "src/app/services/installment-config.service";

@Component({
  selector: "app-secure-installment-config-modal",
  templateUrl: "./installment-config-modal.component.html",
  styleUrls: ["./installment-config-modal.component.scss"],
})
export class InstallmentConfigModalComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  installmentConfigurationType: string;
  header: string;
  installmentType: string;
  installmentOrder: number;
  initialPercent: number;
  otherInstallmentType: string;
  otherInstallmentOrder: number;

  viewInstallmentType: string;
  viewInstallmentOrder: number;
  otherInstallmentNames: string[];

  constructor(
    private modalCtrl: ModalController,
    private installmentConfigService: InstallmentConfigService
  ) {}

  ngOnInit(): void {
    this.viewInstallmentType = this.installmentType;
    console.log("modal - otherInstallmentNames-", this.otherInstallmentNames);
    this.form = new FormGroup({
      otherCharges: new FormControl(this.initialPercent === 0),
      instPaymentInterestRate: new FormControl(null, [
        Validators.pattern(/^\d*\.?\d*$/),
        Validators.max(100),
        Validators.min(0),
      ]),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      installmentDuePaymentDays: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      installmentDuePaymentDaysWithInterest: new FormControl(null, [
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      intrestChartLst: new FormArray([]),
    });

    if (this.initialPercent === 0) {
      this.form.removeControl("installmentPercent");
      this.form.addControl(
        "installmentAmount",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
        ])
      );
      this.form.addControl(
        "otherChargeName",
        new FormControl(null, [Validators.required])
      );
      this.viewInstallmentOrder = this.otherInstallmentOrder;
    } else {
      this.form.removeControl("installmentAmount");
      this.form.removeControl("otherChargeName");
      this.form.addControl(
        "installmentPercent",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.max(this.initialPercent),
          Validators.min(1),
        ])
      );
      this.viewInstallmentOrder = this.installmentOrder;
    }
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;
    selectedIntrestChartLst.push(
      new FormGroup({
        key: new FormControl(null),
        startDate: new FormControl(null, Validators.required),
        endDate: new FormControl(null),
        instPaymentInterestRate: new FormControl(null, Validators.required),
      })
    );
  }
  allowOnlyNumbersAndDecimal(event) {
    const key = event.key;
    const regex = /^[0-9.]$/i;
    return regex.test(key);
  }

  onSelectOtherCharges(e: any) {
    if (e?.target?.checked === true) {
      this.form.removeControl("installmentPercent");
      this.form.addControl(
        "installmentAmount",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
        ])
      );
      this.form.addControl(
        "otherChargeName",
        new FormControl(null, [Validators.required])
      );
      this.viewInstallmentOrder = this.otherInstallmentOrder;
    } else {
      this.form.removeControl("installmentAmount");
      this.form.removeControl("otherChargeName");
      this.form.addControl(
        "installmentPercent",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.max(this.initialPercent),
          Validators.min(1),
        ])
      );
      this.viewInstallmentOrder = this.installmentOrder;
    }
  }

  onSubmit() {
    console.log("this.form.value", this.form.valid);
    if (this.form.valid) {
      if (this.form.value.installmentDuePaymentDaysWithInterest) {
        if (
          this.form.value.installmentDuePaymentDays >
          this.form.value.installmentDuePaymentDaysWithInterest
        ) {
          this.isSubmitDisabled = false;
          alert(
            "Installment Pay days with interest should be more than or equal to Installment Pay days"
          );
        } else {
          return this.modalCtrl.dismiss(
            {
              key: this.viewInstallmentOrder,
              otherCharge: this.form.value.otherCharges ? "Y" : "N",
              installmentType: this.form.value.otherCharges
                ? this.form.value.otherChargeName
                : this.viewInstallmentType,
              installmentPercent: this.form.value.installmentPercent,
              installmentAmount: this.form.value.installmentAmount,
              // instPaymentInterestRate: this.form.value.instPaymentInterestRate,
              installmentDuePaymentDays:
                this.form.value.installmentDuePaymentDays,
              installmentDuePaymentDaysWithInterest:
                this.form.value.installmentDuePaymentDaysWithInterest,
              intrestChartLst: this.form.value.intrestChartLst.map((ur) => ({
                key: this.viewInstallmentOrder,
                // applicationNo: this.applicationNo,
                startDate: ur.startDate,
                endDate: ur.endDate,
                instPaymentInterestRate: ur.instPaymentInterestRate,
              })),
            },
            "submit"
          );
        }
      } else {
        return this.modalCtrl.dismiss(
          {
            key: this.viewInstallmentOrder,
            otherCharge: this.form.value.otherCharges ? "Y" : "N",
            installmentType: this.form.value.otherCharges
              ? this.form.value.otherChargeName
              : this.viewInstallmentType,
            installmentPercent: this.form.value.installmentPercent,
            installmentAmount: this.form.value.installmentAmount,
            instPaymentInterestRate: this.form.value.instPaymentInterestRate,
            installmentDuePaymentDays:
              this.form.value.installmentDuePaymentDays,
            installmentDuePaymentDaysWithInterest:
              this.form.value.installmentDuePaymentDaysWithInterest,
            intrestChartLst: this.form.value.intrestChartLst.map((ur) => ({
              key: ur.key,
              // applicationNo: this.applicationNo,
              startDate: ur.startDate,
              endDate: ur.endDate,
              instPaymentInterestRate: ur.instPaymentInterestRate,
            })),
          },
          "submit"
        );
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }

  onCancel() {
    return this.modalCtrl.dismiss(null, "close");
  }

  // addResponsibility() {
  //   let selectedIntrestChartLst: FormArray = this.form.get(
  //     "intrestChartLst"
  //   ) as FormArray;
  //   if (
  //     selectedIntrestChartLst.length === 0 ||
  //     selectedIntrestChartLst
  //       .at(selectedIntrestChartLst.length - 1)
  //       ?.get("instPaymentInterestRate").value
  //   ) {
  //     if (
  //       selectedIntrestChartLst.length === 0 ||
  //       selectedIntrestChartLst
  //         .at(selectedIntrestChartLst.length - 1)
  //         ?.get("endDate").value
  //     ) {
  // if (
  //   selectedIntrestChartLst.length === 0 ||
  //   selectedIntrestChartLst
  //     .at(selectedIntrestChartLst.length - 1)
  //     ?.get("startDate").value
  // ) {
  //         selectedIntrestChartLst.push(
  //           new FormGroup({
  //             key: new FormControl(null),
  //             startDate: new FormControl(null, Validators.required),
  //             endDate: new FormControl(null),
  //             instPaymentInterestRate: new FormControl(
  //               null,
  //               Validators.required
  //             ),
  //           })
  //         );
  // } else {
  //   this.installmentConfigService.errorToast(
  //     "Start date not selected. Row not added."
  //   );
  // }
  //     } else {
  //       this.installmentConfigService.errorToast(
  //         "End date not selected. Row not added."
  //       );
  //     }
  //   } else {
  //     this.installmentConfigService.errorToast(
  //       "Interest Rate not selected. Row not added."
  //     );
  //   }
  // }
  addResponsibility() {
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;

    if (
      selectedIntrestChartLst.length === 0 ||
      selectedIntrestChartLst
        .at(selectedIntrestChartLst.length - 1)
        ?.get("instPaymentInterestRate").value
    ) {
      if (
        selectedIntrestChartLst.length === 0 ||
        selectedIntrestChartLst
          .at(selectedIntrestChartLst.length - 1)
          ?.get("startDate").value
      ) {
        if (
          selectedIntrestChartLst.length === 0 ||
          selectedIntrestChartLst
            .at(selectedIntrestChartLst.length - 1)
            ?.get("endDate").value
        ) {
          const previousEndDate =
            selectedIntrestChartLst.length > 0
              ? selectedIntrestChartLst
                  .at(selectedIntrestChartLst.length - 1)
                  ?.get("endDate").value
              : null;
          const parsedEndDate =
            previousEndDate !== null ? new Date(previousEndDate) : null;

          const newStartDate =
            parsedEndDate !== null
              ? this.calculateNextDate(parsedEndDate)
              : null;

          selectedIntrestChartLst.push(
            new FormGroup({
              key: new FormControl(null),
              startDate: new FormControl(newStartDate, Validators.required),
              endDate: new FormControl(null),
              instPaymentInterestRate: new FormControl(
                null,
                Validators.required
              ),
            })
          );
        } else {
          this.installmentConfigService.errorToast(
            "End date not selected. Row not added."
          );
        }
      } else {
        this.installmentConfigService.errorToast(
          "Start date not selected. Row not added."
        );
      }
    } else {
      this.installmentConfigService.errorToast(
        "Interest Rate not selected. Row not added."
      );
    }
  }

  calculateNextDate(previousEndDate: Date): Date {
    if (previousEndDate instanceof Date && !isNaN(previousEndDate as any)) {
      const nextStartDate = new Date(previousEndDate);
      nextStartDate.setDate(previousEndDate.getDate() + 1);

      return nextStartDate;
    } else {
      // Handle the case where previousEndDate is not a valid Date
      return null; // Or handle it according to your logic
    }
  }

  get DetailOfFamilyMembers() {
    return this.form.get("intrestChartLst")["controls"];
  }

  deleteResponsibility(i: number) {
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;
    selectedIntrestChartLst.removeAt(i);
  }
}
